<template>
  <b-row class="border h-100">
    <b-col class="tsny_box-padding">
      <b-row>
        <b-col>
          <h2 class="tsny_header">Course Resources</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          ><p v-if="!resources.length" class="tsny_text">
            This course doesn't have any resources yet
          </p>
          <ul class="tsny_resources-list">
            <li
              class="tsny_text"
              :key="resource._id"
              v-for="resource in resources"
            >
              <course-resource :resource="resource" />
            </li></ul
        ></b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import CourseResource from "../CourseAdministration/CourseResource";
export default {
  name: "CourseResources",
  components: { CourseResource },
  props: {
    resources: {
      type: Array,
      default: null
    }
  }
};
</script>

<style scoped>
ul {
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
</style>
